<template>
  <v-tab-item :key="2" :value="'tab-2'">
    <v-row justify="center">
      <v-col cols="12">
        <v-card ref="form" outlined flat>
          <v-card-text>
            <v-text-field
              label="Lớp hoặc Tuổi "
              v-model="age"
              placeholder="Nhập lớp, hoặc tuổi của học sinh"
            ></v-text-field>
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateFormatted"
                  label="Ngày Trải Nghiệm"
                  @blur="date = parseDate(dateFormatted)"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker locale="vn" v-model="date" no-title @input="menu1 = false"></v-date-picker>
            </v-menu>
            <v-select
              :items="times"
              label="Giờ Trải Nghiệm"
              placeholder="Chọn giờ trải nghiệm"
              v-model="meetingTime"
            ></v-select>
            <v-select
              :items="subjects"
              label="Nội Dung Trải Nghiệm "
              v-model="meetingSubject"
              placeholder="Chọn Nội dung trải nghiệm"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn depressed small right color="red" @click="cancel">Cancel</v-btn>
            <v-btn depressed small color="green" style="margin: 0 20px" @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-tab-item>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    contact: { type: [Object], required: true, default: () => {} }
  },
  data: vm => ({
    date: moment().format('YYYY-MM-DD'),
    times: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
    subjects: [
      'Kodu Game Labs',
      'Game Maker',
      'C4T Python',
      'C4K Web',
      'C4T JS'
    ],
    meetingSubject: '',
    dateFormatted: moment().format('DD/MM/YYYY'),
    menu1: false,
    meetingTime: 9,
    age: 'Lớp 7'
  }),

  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    }
  },

  watch: {
    date (val) {
      this.dateFormatted = this.formatDate(this.date)
    },
    contact (contact) {
      this.dateFormatted = moment(contact.meetingDate).format('DD/MM/YYYY')
      this.date = moment(contact.meetingDate).format('YYYY-MM-DD')
      this.age = this.contact.age
      this.meetingTime = new Date(contact.meetingDate).getHours()
      this.meetingSubject = this.contact.meetingSubject
    }
  },

  methods: {
    formatDate (date) {
      if (!date) return null
      return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    parseDate (date) {
      return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD')
    },
    save () {
      this.$emit('save', {
        meetingDate: moment(
          this.dateFormatted + '-' + this.meetingTime,
          'DD/MM/YYYY-hh'
        ).toISOString(),
        meetingSubject: this.meetingSubject,
        age: this.age
      })
    },
    cancel () {
      this.dateFormatted = moment(this.contact.meetingDate).format('DD/MM/YYYY')
      this.date = moment(this.contact.meetingDate).format('YYYY-MM-DD')
      this.age = this.contact.age
    }
  }
}
</script>
